import {
  GetterTree
} from 'vuex'
import { TRootState } from '../types'
import { OperationsState } from './types'

export default {} as GetterTree<OperationsState, TRootState>
